import React from "react";
import "./accordion.css";
import { HiMiniArrowUpCircle, HiMiniArrowDownCircle } from "react-icons/hi2";

const Accordion = ({ title, isActive, onClick, children, className }) => {
  return (

    <div className="accordion-section">
      <div className={`accordion-cards ${className ? className : ""}`} onClick={onClick}>
        <h3 className="accordion-title">{title}</h3>
        <span className="accordion-icon">
          {isActive ? (
            <HiMiniArrowUpCircle />
          ) : (
            <HiMiniArrowDownCircle />
          )}
        </span>
      </div>
      {/* Content → Render only when active */}
      {isActive && (
        <div className="accordion-content">
          {children}
        </div>
      )}
    </div>

  );
};

export default Accordion;
